import { useTranslation } from 'react-i18next';

/** Optional per-document override; the server validates the same inclusive bounds. */
export function FollowUpInput({ value, onChange }: { value: number | null; onChange: (value: number | null) => void }) {
  const { t } = useTranslation();
  return <label className="block space-y-1 text-xs">{t('quotes.customFollowUpHours')}
    <input type="number" min={1} max={720} step={1} value={value ?? ''} placeholder={t('common.optional')} onChange={(event) => { const hours = event.target.value === '' ? null : Number(event.target.value); if (hours === null || (Number.isInteger(hours) && hours >= 1 && hours <= 720)) onChange(hours); }} className="h-9 w-full rounded-lg border border-border bg-background px-2" />
  </label>;
}
